/**
 * 预览表格配置 - 用于 BaseListManagement
 */
export const previewTableConfig = ({
  togglePlansExpand,
  toggleStoresExpand,
  getExpandState,
  apiFn,
}) => ({
  isShowDepartment: false,
  formData: {
    // 空表单配置，PreviewTable 不需要搜索表单
    formProps: {
      model: {},
    },
    list: [],
  },
  tableData: {
    apiFn,
    attrs: {},
    columns: [
      {
        name: 'productName',
        columnProps: {
          prop: 'productName',
          label: '商品',
          minWidth: 200,
        },
        render: ({ row }) => {
          return (
            <div class="product-cell">
              <span class="product-name">{row.productName}</span>
              <el-tag size="mini" type="info">
                {row.cityName}
              </el-tag>
            </div>
          )
        },
      },
      {
        name: 'rentPlanList',
        columnProps: {
          prop: 'rentPlanList',
          label: '租赁方案',
          minWidth: 240,
        },
        render: ({ row }) => {
          const plans = row.rentPlanList || []
          const planNames = plans.map(
            (plan) => plan.planName || plan.rentPeriodInfo,
          )
          const isExpanded = getExpandState(row, 'plansExpanded')
          const plansToShow = isExpanded ? planNames : planNames.slice(0, 2)
          return (
            <div class="plans-cell">
              {plansToShow.map((plan, index) => (
                <div key={index} class="plan-item">
                  • {plan}
                </div>
              ))}
              {planNames.length > 2 && (
                <el-link
                  type="primary"
                  underline={false}
                  onClick={() => togglePlansExpand(row)}
                >
                  {isExpanded ? '收起' : `共${planNames.length}个方案，展开`}
                </el-link>
              )}
            </div>
          )
        },
      },
      {
        name: 'carInfo',
        columnProps: {
          prop: 'carInfo',
          label: '车型信息',
          width: 180,
        },
        render: ({ row }) => {
          const parts = [
            row.ageName,
            row.mileageName,
            row.carCert === 1 ? '有车证' : '无车证',
          ].filter(Boolean)
          return parts.join(' · ')
        },
      },
      {
        name: 'storeNameList',
        columnProps: {
          prop: 'storeNameList',
          label: '门店',
          minWidth: 200,
        },
        render: ({ row }) => {
          const stores = row.storeNameList || []
          const isExpanded = getExpandState(row, 'storesExpanded')
          const storesToShow = isExpanded ? stores : stores.slice(0, 2)
          return (
            <div class="stores-cell">
              {storesToShow.map((store, index) => (
                <div key={index} class="store-item">
                  {store}
                </div>
              ))}
              {stores.length > 2 && (
                <el-link
                  type="primary"
                  underline={false}
                  onClick={() => toggleStoresExpand(row)}
                >
                  {isExpanded ? '收起' : '展开'}
                </el-link>
              )}
            </div>
          )
        },
      },
    ],
    pagination: {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pagerCount: 5,
    },
  },
})
